<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
      id="editModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Update Client"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="fullName">Name</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Full Name"
                          rules="required"
                      >
                        <b-form-input
                            id="fullName"
                            v-model="updatedAdmin.name"
                            name="fullName"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="mobile">Mobile</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Mobile"
                          rules="required"
                      >
                        <b-form-input
                            id="mobile"
                            v-model="updatedAdmin.mobile"
                            name="mobile"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="email">Email</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Email"
                          rules="required|email"
                      >
                        <b-form-input
                            id="email"
                            v-model="updatedAdmin.email"
                            type="email"
                            name="email"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="first_name">Roles</label>
                      <validation-provider
                          #default="{ errors }"
                          name="roles"
                          rules="required"
                      >
                        <v-select
                            name="roles"
                            v-model="updatedAdmin.roles"
                            class="parent-service"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="roles"
                            :reduce="name => name.id"
                            label="name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import ToastificationContent from '@core/components/toastification/ToastificationContent'
import adminService from '../../../services/adminService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['admin'],
  data() {
    return {
      roles: [],
      updatedAdmin: {
        title: '',
        name: '',
        mobile: '',
        email: '',
        roles: ''
      },
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      codeBasic,
    }
  },
  mounted() {
    this.getRoles()
    this.$watch(() => this.admin, admin => {
      console.log(admin)
      this.updatedAdmin = {
        name: admin.full_name,
        mobile: admin.phone,
        email: admin.email,
        roles: admin.roles[0].id
      }
    })
  },
  methods: {
    getRoles() {
      this.loading = true
      adminService.adminRoles()
          .then(response => {
            this.roles = response.data.data
          })
    },
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              adminService.putAdmin(this.admin.id, {...this.updatedAdmin, roles: [this.updatedAdmin.roles]})
                  .then(response => {
                    if (response && response.data.code === 200) {
                      this.$emit('refresh', 'true')
                      $('#editModal').modal('hide')

                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: 'Admin Is Updated Successfully !',
                        },
                      })
                    } else{
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Error',
                          icon: 'CheckIcon',
                          variant: 'danger',
                          text: response.data.message,
                        },
                      })
                      $('#editModal').modal('hide')
                    }
                    this.loading = false
                  })
            }
          })
          .catch(function (error) {
            alert(error)

            $('#editModal')
                .modal('hide')
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'Error',
                text: 'Error !',
              },
            })
            return Promise.reject(error)
          })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
